import { GraphQLOptions } from '@moonpig/web-core-graphql'
import { createProxyApiUrl, isMobileUserAgent } from '@moonpig/web-core-utils'
import type { NextPageContext } from 'next'
import { getCookies } from '@moonpig/web-core-browser-storage'
import { getProxyApiStoreNamespace } from './proxyApiStoreNamespace'

const enableMockingByUrl = (ctx: NextPageContext) => {
  const rawUrl = ctx.req?.headers['Mnpg-Raw-Url']

  if (process.env.NEXT_PUBLIC_API_MOCKING !== 'true' || !rawUrl) {
    return
  }

  return { 'mnpg-request-url': rawUrl }
}

const setUpProxyApi = (proxyApiStoreNamespace: string | null) => {
  if (!proxyApiStoreNamespace) {
    return
  }

  return {
    'mnpg-contentful-environment-id': 'e2e',
    'mnpg-proxy-api-store-namespace': proxyApiStoreNamespace,
  }
}

const cookieOverideContentful = (ctx: NextPageContext) => {
  if (!getCookies(ctx)['mnpg_use-e2e-contentful']) {
    return
  }

  return {
    'mnpg-contentful-environment-id': 'e2e',
  }
}

export const getGraphQLOptions = ({
  ctx,
  sessionId,
  storeId,
}: {
  ctx: NextPageContext
  localHostName: string
  sessionId: string
  storeId: string
}): GraphQLOptions => {
  if (!process.env.AUTH_URL) {
    throw new Error('env variable AUTH_URL must be defined')
  }

  const headers = {
    'mnpg-client-name': 'web',
    'mnpg-session-id': sessionId,
    'mnpg-store': storeId,
    'mnpg-is-mobile-browser': isMobileUserAgent() ? 'true' : 'false',
    ...setUpProxyApi(getProxyApiStoreNamespace(ctx)),
    ...enableMockingByUrl(ctx),
    ...cookieOverideContentful(ctx),
  }

  const usePersistedQueries = !(
    process.env.ENABLE_PROXY_API || !!getProxyApiStoreNamespace(ctx)
  )

  return {
    authBaseUrl: createProxyApiUrl(process.env.AUTH_URL),
    headers,
    usePersistedQueries,
  }
}
